import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FilterTile from './FilterTile';
import { useBuildJourneyFilterStrategy } from './useBuildJourneyFilterStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddFilterButton = ({
  beginEditingFilter,
  disabled
}) => {
  return /*#__PURE__*/_jsxs(Button, {
    use: "transparent",
    onClick: beginEditingFilter,
    "data-test-id": "property-filter-add-button",
    disabled: disabled,
    paddingInline: "0",
    paddingBlockStart: "100",
    children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.journeyPropertyFilter.addButton"
    })]
  });
};
const AndSeparator = ({
  isLast,
  addFilter
}) => {
  const andText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-enablement.reportEditors.journeyPropertyFilter.and"
  });
  return isLast ? /*#__PURE__*/_jsx(Button, {
    onClick: addFilter,
    use: "tertiary-light",
    size: "extra-small",
    marginBlockStart: "200",
    children: andText
  }) : /*#__PURE__*/_jsx(View, {
    borderInlineStartStyle: "solid",
    borderInlineStartColor: "border-core-default",
    borderInlineStartWidth: "100",
    marginBlock: "200",
    marginInline: "0",
    paddingBlock: "50",
    paddingInline: "300",
    children: /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "detail-100",
      children: andText
    })
  });
};
const FilterOverview = ({
  objectTypeId,
  properties,
  filterSet: {
    filters
  },
  setActiveEditingFilter,
  deleteFilter,
  disabled = false,
  isMultiFilterAllowed = true
}) => {
  const strategy = useBuildJourneyFilterStrategy({
    properties,
    dataType: objectTypeId
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "journey-filter-overview-container",
    children: filters.length === 0 ? /*#__PURE__*/_jsx(AddFilterButton, {
      disabled: disabled,
      beginEditingFilter: () => setActiveEditingFilter(0)
    }) : filters.map((filter, index) =>
    /*#__PURE__*/
    // FIXME: Don't use the index as a key
    // eslint-disable-next-line react/no-array-index-key
    _jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FilterTile
      // FIXME: Don't use the index as a key
      // eslint-disable-next-line react/no-array-index-key
      , {
        properties: properties,
        filter: filter,
        objectTypeId: objectTypeId,
        editFilter: () => setActiveEditingFilter(index),
        deleteFilter: () => deleteFilter(index),
        strategy: strategy
      }, index), isMultiFilterAllowed && /*#__PURE__*/_jsx(AndSeparator, {
        isLast: index === filters.length - 1,
        addFilter: () => setActiveEditingFilter(index + 1)
      })]
    }, index))
  });
};
export default FilterOverview;